import { render, staticRenderFns } from "./NowLine.vue?vue&type=template&id=20492846&"
import script from "./NowLine.vue?vue&type=script&lang=js&"
export * from "./NowLine.vue?vue&type=script&lang=js&"
import style0 from "./NowLine.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports